export const AUTO_ACCEPTED = 'AUTO_ACCEPTED';
export const ACCEPTED = 'ACCEPTED';
export const REQUIRES_REVIEW = 'REQUIRES_REVIEW';
export const REJECTED = 'REJECTED';

export const DOCUMENT_REVIEW_STATUS = {
  AUTO_ACCEPTED,
  ACCEPTED,
  REQUIRES_REVIEW,
  REJECTED,
};

export function documentReviewStatusToReadableLabel(reviewStatus) {
  switch (reviewStatus) {
    case DOCUMENT_REVIEW_STATUS.AUTO_ACCEPTED:
      return 'Auto Accepted';
    case DOCUMENT_REVIEW_STATUS.ACCEPTED:
      return 'Accepted';
    case DOCUMENT_REVIEW_STATUS.REQUIRES_REVIEW:
      return 'Requires Review';
    case DOCUMENT_REVIEW_STATUS.REJECTED:
      return 'Rejected';
    default:
      return '';
  }
}
